(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelguide/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/spelguide/assets/javascripts/init.js');
"use strict";


document.title = svs.spelguide.data.title;

 })(window);